import { render } from "./DetailingContract.vue?vue&type=template&id=1783e9d0&scoped=true"
import script from "./DetailingContract.js?vue&type=script&lang=js"
export * from "./DetailingContract.js?vue&type=script&lang=js"

import "./DetailingContract.scss?vue&type=style&index=0&id=1783e9d0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1783e9d0"]])

export default __exports__